import { render, staticRenderFns } from "./add-measure-modal.vue?vue&type=template&id=fc020174"
import script from "./add-measure-modal.vue?vue&type=script&lang=ts"
export * from "./add-measure-modal.vue?vue&type=script&lang=ts"
import style0 from "./add-measure-modal.vue?vue&type=style&index=0&id=fc020174&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports